import { Alert, Icon, IconButton } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FormTemplateTypeEnum } from "../../_common/enum/forms/fomTemplateType.enum";
import { FormStatusEnum } from "../../_common/enum/forms/formStatus.enum";
import { FormStatusAdminEnum } from "../../_common/enum/forms/formStatusAdmin.enum";
import { IFilteringViewModel, ITableData } from "../../_common/interface/table";
import { CommonTable } from "../../_components/table/common.table";
import { PaperTableHeader } from "../../_components/table/header.table";
import { SearchTableHeader } from "../../_components/table/search.table";
import { TABLE_FILTER } from "../../_const/tableFilter.const";
import { getDateTime } from "../../_helpers/dateTime.helper";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { formService } from "../../_services/form.service";
import { DataTypeEnum } from "../../_common/enum/dataType.enum";


export function FormIndex(params: { formType?: FormTemplateTypeEnum, title: string, id: any }) {

    const [data, setData] = useState<ITableData<any>>({ items: [], count: 0 });
    const [isLoading, setLoading] = useState(true);
    const [filter, setFilter] = useState<IFilteringViewModel>({ ...TABLE_FILTER, id: params.id, formTemplateTypeId: Number(params.formType) });
    var url = params.formType == FormTemplateTypeEnum.Centre ? '/Centre/Details/' : params.formType == FormTemplateTypeEnum.Client ? '/Client/Details/' : '';


    let navigate = useNavigate();

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                id: 'actions',
                header: 'Actions',
                size: 80,
                enableSorting: false,
                enableColumnFilter: false,
                Cell: ({ row }) => (<>
                    <IconButton
                        color="primary"
                        onClick={() => window.open(`${url}${params.id}/Forms/${row.original.id}`, "_blank")
                        }>
                        <Icon>edit</Icon>
                    </IconButton>
                </>
                ),
            },
            {
                accessorKey: 'referenceNumber',
                header: 'Reference',
            },
            {
                accessorKey: 'createdDate',
                header: 'Created Date',
                accessorFn: (rowData: any) => <>{rowData.createdDate ? getDateTime(rowData.createdDate) : "-"}</>,
            },
            {
                accessorKey: 'modifiedDate',
                header: 'Modified Date',
                accessorFn: (rowData: any) => <>{rowData.modifiedDate ? getDateTime(rowData.modifiedDate) : "-"}</>,
            },
            {
                accessorKey: 'modifiedBy',
                header: 'Modified By',
            },
            {
                accessorKey: 'name',
                header: 'Name',
            },
            {
                accessorKey: 'topic',
                header: 'Topic',
            },

            {
                accessorKey: 'formStatusId',
                header: 'Form Status',
                accessorFn: (rowData: any) => <>
                    {
                        rowData.formStatusId == FormStatusEnum.New ? FormStatusEnum[rowData.formStatusId] :
                            rowData.formStatusId == FormStatusEnum.Approved ? <Alert severity="success">{FormStatusEnum[rowData.formStatusId]}</Alert> :
                                rowData.formStatusId == FormStatusEnum.AwaitingApproval ? <Alert severity="warning">{FormStatusEnum[rowData.formStatusId]}</Alert> :
                                    rowData.formStatusId == FormStatusEnum.Withdrawn ? <Alert severity="warning">{FormStatusEnum[rowData.formStatusId]}</Alert> :
                                        rowData.formStatusId == FormStatusEnum.Cancelled ? <Alert severity="error">{FormStatusEnum[rowData.formStatusId]}</Alert> :
                                            <></>}
                </>,
            },

        ],
        [],
    );

    useEffect(() => {
        if (filter) fetchData();
    }, [filter]);


    function fetchData() {
        setLoading(true);
        return formService.getAll({ ...filter })
            .then(
                data => {
                    setData(data);
                }, handleErrorResponse)
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <>

            <PaperTableHeader title="Forms" />

            <SearchTableHeader inputs={[
                { label: "Form Type", name: "formTemplateId", type: "autocomplete", dataType: DataTypeEnum.FormTemplate, parentId: params.formType, onChange: setFilter, value: filter.formTemplateId, width: 250 },
                { label: "From Date", name: "fromDate", type: "date", onChange: setFilter, value: filter.fromDate },
                { label: "To Date", name: "toDate", type: "date", onChange: setFilter, value: filter.toDate },
            ]} />

            <CommonTable
                columns={columns}
                data={data}
                filter={filter}
                setFilter={setFilter}
                loading={isLoading}
            />

        </>
    );

}
